import { Enum } from './Enum';

export class BiannualAppointmentStatus extends Enum {
  translationKey = 'biannualAppointmentStatus';

  static asArray: BiannualAppointmentStatus[] = [];

  static byKey: { [name: string]: BiannualAppointmentStatus } = {};

  static readonly COMPLETED = new BiannualAppointmentStatus('COMPLETED');

  static readonly PENDING = new BiannualAppointmentStatus('PENDING');

  static readonly RESCHEDULE_NEEDED = new BiannualAppointmentStatus(
    'RESCHEDULE_NEEDED',
  );

  static readonly RESCHEDULE_FUTURE_MONTH = new BiannualAppointmentStatus(
    'RESCHEDULE_FUTURE_MONTH',
  );

  static readonly NOT_YET_SCHEDULED = new BiannualAppointmentStatus(
    'NOT_YET_SCHEDULED',
  );

  static toSelectable() {
    return Enum.toSelectable(BiannualAppointmentStatus.asArray);
  }

  constructor(public readonly value: string) {
    super();
    BiannualAppointmentStatus.asArray.push(this);
    BiannualAppointmentStatus.byKey[value] = this;
  }
}

export default BiannualAppointmentStatus;
